// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.saleschannels.new', {
        url:'/new',
        views: {"productView@product": {
            templateUrl: 'main/product/saleschannels/saleschannel/saleschannel.tpl.html',
            controller: 'SalesChannelController as vm'
        }},
        resolve: {
            salesChannel: function() { return {}; },
            isNewSalesChannel: function() { return true; },
            tenantConfig: tenantConfigResolver,
            pricelists: pricelistsResolver,
            countries: countriesResolver
        }
    });

    $stateProvider.state('product.saleschannels.saleschannel', {
        url:'/{salesChannelId}',
        views: {"productView@product": {
            templateUrl: 'main/product/saleschannels/saleschannel/saleschannel.tpl.html',
            controller: 'SalesChannelController as vm'
        }},
        resolve: {
            salesChannel: salesChannelResolver,
            isNewSalesChannel: function() { return false; },
            tenantConfig: tenantConfigResolver,
            pricelists: pricelistsResolver,
            countries: countriesResolver
        }
    });

}

// @ngInject
function salesChannelResolver($stateParams, SalesChannelsApiService) {
    return SalesChannelsApiService.getSalesChannel($stateParams.salesChannelId);
}

// @ngInject
function tenantConfigResolver(SalesChannelsApiService) {
    return SalesChannelsApiService.getTenantConfig();
}

// @ngInject
function pricelistsResolver(SalesChannelsApiService) {
    return SalesChannelsApiService.getPricelists();
}

// @ngInject
function countriesResolver(SalesChannelsApiService) {
    return SalesChannelsApiService.getCountries();
}


// @ngInject
function SalesChannelController($state, salesChannel, loadSpinnerService, SalesChannelsApiService, isNewSalesChannel, tenantConfig, pricelists, countries) {
    var vm = this;

    var salesChannelCopy = {};

    vm.salesChannel = salesChannel;

    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveSalesChannel = saveSalesChannel;

    vm.isNewSalesChannel = isNewSalesChannel;
    vm.isEditing = vm.isNewSalesChannel;

    vm.tenantConfig = tenantConfig;
    vm.isAllInformationValid = isAllInformationValid;
    vm.isSalesChannelCodeValid = isSalesChannelCodeValid;
    vm.pricelists = pricelists;
    vm.countries = countries;

    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactSalesChannelView') !== 'false';

    activate();

    function activate() {
        prepareData();

        if (vm.isNewSalesChannel) {
            vm.salesChannel = {};
        }
    }

    function enableEditing() {
        salesChannelCopy = angular.copy(vm.salesChannel);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.salesChannel = salesChannelCopy;
        vm.isEditing = false;
    }

    function saveSalesChannel() {
        if (vm.isNewSalesChannel) {
            saveNewSalesChannel();
        } else {
            updateSalesChannel();
        }
    }

    function saveNewSalesChannel() {
        loadSpinnerService.start('mainSpinner');
        SalesChannelsApiService.createSalesChannel(vm.salesChannel).then(function(response) {
            vm.SalesChannel = response;
            prepareData();
            vm.isNewSalesChannel = false;
            vm.isEditing = false;
            $state.go('product.saleschannels.saleschannel', {salesChannelId: response.id});
        }, function(error) {
            console.log(error);
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updateSalesChannel() {
        loadSpinnerService.start('mainSpinner');
        SalesChannelsApiService.updateSalesChannel(vm.salesChannel).then(function(response) {
            vm.salesChannel = response;
            prepareData();
            vm.isEditing = false;
        }, function(error) {
            console.log(error);
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function prepareData() {
        if (vm.salesChannel === undefined) {
            return;
        }
    }

    function isAllInformationValid() {
        return !vm.isNewSalesChannel ||
            (isSalesChannelCodeValid());
    }

    function isSalesChannelCodeValid() {
        var isSalesChannelCodeAlreadyAssigned = _.find(vm.tenantConfig.assignedSalesChannelCodes, function(code) {
            return vm.salesChannel.salesChannelCode === code;
        });

        if (!isSalesChannelCodeAlreadyAssigned) {
            return true;
        } else {
            return false;
        }
    }
}

angular
    .module('saleschannels.saleschannel', [])
    .config(stateConfig)
    .controller('SalesChannelController', SalesChannelController);
